import React from 'react';
import { Popup } from 'semantic-ui-react';
import { catalogRecencyTextV1021 } from './catalogRecencyV1021';
import './catalogRecencyV1021.css';

export default function RegisteredChannelsV1021({ item, root, language }) {
  if (!root) return null;
  const text = catalogRecencyTextV1021(language);
  const channels = Array.isArray(item.registered_channels_v1021)
    ? item.registered_channels_v1021
    : [];
  const label = `${text.channels}: ${item.channel_count_v1018 || 0}`;
  return (
    <Popup
      on={['hover', 'focus', 'click']}
      closeOnTriggerClick={false}
      hoverable
      position='top left'
      className='model-channels-popup-v1021'
      trigger={
        <button
          type='button'
          className='model-channels-trigger-v1021'
          aria-label={label}
        >
          {label}
        </button>
      }
      content={
        <div role='tooltip' aria-label={text.channels}>
          {channels.length ? (
            <ul className='model-channels-list-v1021'>
              {channels.map((channel) => (
                <li key={channel.id}>
                  <strong>{channel.name || `#${channel.id}`}</strong>
                  <span>
                    #{channel.id} /{' '}
                    {channel.status === 1
                      ? text.enabled
                      : channel.status === 2
                      ? text.manual
                      : channel.status === 3
                      ? text.automatic
                      : text.unknown}
                  </span>
                </li>
              ))}
            </ul>
          ) : (
            text.empty
          )}
        </div>
      }
    />
  );
}
